import { useRouter } from 'next/dist/client/router';
import classNames from 'classnames';

import { NavigationAnchor } from '@components/navigation/NavigationAnchor';

import { getNavigationAnchor } from '@common/utils/navigation';
import { NavigationLinkGroup } from '@interfaces';

import styles from './navigation-link-block.module.scss';

interface NavigationLinkBlockProps extends Omit<NavigationLinkGroup, 'id'> {
	className?: string;
	external?: boolean;
}

export const NavigationLinkBlock = ({
	title,
	links,
	className,
	external = false,
}: NavigationLinkBlockProps) => {
	const router = useRouter();
	return (
		<div className={classNames(className, styles.list)}>
			<h2 className={styles.heading}>{title}</h2>
			<ul className={classNames(styles.list, 'list-unstyled')}>
				{links?.map((link) => {
					const anchor = getNavigationAnchor(router, link);

					if (!anchor) {
						return null;
					}

					if (external) {
						return (
							<li key={link.id}>
								<NavigationAnchor
									className={classNames(styles.link, 'anchor', {
										'anchor--external-arrow-style-diagonal': external,
									})}
									url={anchor.url}
								>
									{anchor.title}
								</NavigationAnchor>
							</li>
						);
					}

					return (
						<li key={link.id}>
							<NavigationAnchor {...anchor}>{anchor.title}</NavigationAnchor>
						</li>
					);
				})}
			</ul>
		</div>
	);
};
